import {
  Text,
  Heading,
  ActionButton,
  MenuTrigger,
  Menu,
  MenuItem,
  Avatar,
  Link,
} from "@react-spectrum/s2";
import ChevronDownIcon from "@react-spectrum/s2/icons/ChevronDown";
import LinkOutIcon from "icon:@app/assets/S2_LinkOutSize100.svg";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };
import { headingStyle } from "../style" with { type: "macro" };

export const PersonaSelect = ({
  personas,
  selectedPersona,
  setSelectedPersona,
  previewUrl,
}) => {
  return (
    <div className={style({ width: 360, maxWidth: "full" })}>
      <Heading styles={style(headingStyle())}>
        <Text>Persona preset</Text>
      </Heading>
      <p
        className={style({
          font: "body-sm",
          marginTop: 0,
          marginBottom: 24,
        })}
      >
        Pick one persona to shape your story&apos;s voice and perspective.
        <br />
        The photo is predefined for now.
      </p>

      <div
        className={style({
          display: "flex",
          alignItems: "center",
          gap: 8,
        })}
      >
        <Avatar
          src={selectedPersona?.avatarUrl}
          alt="Persona photo"
          size={64}
          isOverBackground
        />
        <MenuTrigger direction="bottom end">
          <ActionButton
            aria-label="Select persona type"
            isQuiet
            // size="S"
          >
            <div
              className={style({
                gridArea: "text",
                display: "flex",
                gap: 12,
                alignItems: "center",
              })}
            >
              <Text styles={style({ font: "title" })}>
                {selectedPersona?.type}
              </Text>
              <ChevronDownIcon slot={null} />
            </div>
          </ActionButton>
          <Menu
            items={personas}
            selectionMode="single"
            selectedKeys={[selectedPersona?.id]}
            onSelectionChange={([key]) => setSelectedPersona(key)}
            aria-label="Persona types preset"
          >
            {(persona) => (
              <MenuItem id={persona.id}>
                <Avatar
                  slot="avatar"
                  src={persona.avatarUrl}
                  // size={32}
                  alt={`${persona.type} photo`}
                />
                <Text slot="label">{persona.type}</Text>
              </MenuItem>
            )}
          </Menu>
        </MenuTrigger>
      </div>
      {!!previewUrl && (
        <div
          className={style({
            display: "flex",
            alignItems: "end",
            justifyContent: "start",
            gap: 8,
            marginTop: 8,
          })}
        >
          <Text slot="description" styles={style({ font: "body-sm" })}>
            See how each persona looks
          </Text>
          <Link
            href={previewUrl}
            target="_blank"
            isStandalone
            staticColor="auto"
            slot="contextualHelp"
          >
            <Text slot="description" styles={style({ font: "body-sm" })}>
              Preview
            </Text>
            <LinkOutIcon styles={style({ size: 8, marginStart: 8 })} />
          </Link>
        </div>
      )}
    </div>
  );
};
